import React from "react";
import TrashIcon from "../Icon/TrashIcon";

const TimeSlotDeleteButton = (props) => {
  return (
    <div className="time-slot-delete">
      <div className="time-slot-delete links" onClick={props.handleOnClick}>
        <TrashIcon />
        <span className="time-slot-delete-text">Delete time slot</span>
      </div>
    </div>
  );
};

export default TimeSlotDeleteButton;
